import DescriptionList from '@anwb/poncho/components/description-list';
import Grid from '@anwb/poncho/components/grid';

import { Upgrade } from '../../../../../../../types';

import { UpgradeDescriptionListItems } from './UpgradeDescriptionListItems';

type Props = {
	selectedVehicle: Upgrade | undefined;
};

export const UpgradeDescriptionList = ({ selectedVehicle }: Props) => {
	if (!selectedVehicle) {
		return null;
	}

	return (
		<Grid.Item>
			<DescriptionList items={UpgradeDescriptionListItems({ selectedVehicle })} />
		</Grid.Item>
	);
};
